import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-voucher-result-box',
  templateUrl: './voucher-result-box.component.html',
  styleUrls: ['./voucher-result-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VoucherResultBoxComponent {
  @Input() success: boolean;
}
